import { JobDetailModel } from "src/store/models/ui/job/jobDetail";
import { JobTableUIModel } from "src/store/models/ui/job/jobTable";
import { RunningMonitorModel } from "src/store/models/ui/job/runningMonitor";

export const encooJobUIModels = {
  jobTable: JobTableUIModel,
  jobDetail: JobDetailModel,
  runningMonitor: RunningMonitorModel,
};
